// removed by extract-text-webpack-plugin
module.exports = {"InfoLink":"_3gduFmduvYrL31ulBIVQg_"};


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/components/InfoLink.scss
// module id = 1238
// module chunks = 0